<template>
  <transition name="slide-y-transition">
    <div>
      <div class='fl hf mb-4'>
        <div class='csv-left'>
          <v-icon class='icon' size='30'>attach_file</v-icon>
          <h1>*.csv</h1>
        </div>
        <div class='csv-right'>
          <h6 class='mb-2'>Invulformaat Importeerbestand Verzuimen</h6>
          <p>Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst in deze bedrijfstak sinds de 16e eeuw, toen een onbekende drukker een zethaak met letters nam en ze door elkaar husselde om een font-catalogus te maken. </p>
        </div>
      </div>
      <form-input-container
        :title="$t('reports-of-sickness-import.fields.import-file')"
        :text="$t('reports-of-sickness-import.guides.import-file')">
        <file-upload placeholder="Upload Bestand" v-model="importFile" accept='.csv'>
          <v-icon slot="left">assignment</v-icon>
        </file-upload>
        <span style='float: right; font-size: 0.9em; margin-top: 5px;'>max. 20MB, enkel *.csv</span>
      </form-input-container>
      <div style='float: right' class='mt-2'>
        <Button primary class="mr-3" @click="this.handleCancel">
          {{ 'buttons.cancel' | translate }}
        </Button>
        <Button secondary @click="this.handleImportClick" :disabled="importFile == null" :hoverErrors="hoverErrors">
          Start Import
        </Button>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import RosImportConstants from '@/views/constants/reports-of-sickness-import-new';

import FileUpload from '@aevitae/aevitaeui/0_atoms/input/FileUpload.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

export default {
  name: 'ReportsOfSicknessFileUpload',
  components: {
    Button,
    FileUpload,
    FormInputContainer
  },
  computed: {
    importFile: {
      get () { return this.$store.getters.reportsOfSicknessNewImportFile; },
      set (v) { this.$store.dispatch(RosImportConstants.Actions.SELECT_FILE, v); }
    },
    hoverErrors () {
      if (this.importFile == null) {
        return ['Selecteer een bestand om te importeren'];
      } else return null;
    }
  },
  methods: {
    handleCancel () {
      this.$store.dispatch(RosImportConstants.Actions.CANCEL);
    },
    handleImportClick () {
      this.$store.dispatch(RosImportConstants.Actions.NAVIGATE, RosImportConstants.Views.ImportReport);
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.import-explain {

  background-color: $gray-lighten-2;
  border-radius: $border-radius;
  padding: 40px;
}

.csv-left {
  position: relative;
  padding: 30px;
  background-color: $positive-lighten-3;
  border-top-left-radius: $border-radius;
  border-bottom-left-radius: $border-radius;

  h1 {
    position: absolute;
    bottom: 25px;
    color: $positive;
    font-size: 1.4em;
  }
}

.csv-right {
  position: relative;
  width: 100%;
  background-color: white;
  border: $gray-lighten-1 1px solid;
  // border-left: 0;
  border-left: $positive-lighten-2 1px solid;
  padding: 25px 30px;
  border-top-right-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

.icon {
  background-color: $positive;
  fill: white;
  color: white;
  padding: 12px;
  display: block;
  border-radius: $border-radius;
}

</style>
